/// <amd-module name="VSS/Redux/Modules/Shortcuts/ShortcutsSaga" />
import { AnyAction } from "redux";
import { channel, Channel, effects } from "redux-saga";
import { ActionsOfType } from "redux/Utils/ActionHelper";
import { IVssPageContext } from "VSS/Platform/Context";
import { IEKeyboardEvent, IVssKeyboardShortcutService } from "VSS/Platform/KeyboardShortcuts";
import { ShortcutsActions, ShortcutsActionTypes } from "./ShortcutsActions";

export function* shortcutsSaga() {
    const actionQueue: Channel<AnyAction> = (yield effects.call(channel)) as any;
    const registeredGroups: string[] = [];

    try {
        yield effects.takeEvery(ShortcutsActionTypes.RegisterShortcutGroup, registerShortcuts, actionQueue, registeredGroups);
        yield effects.takeEvery(ShortcutsActionTypes.UnRegisterShortcutGroup, unregisterShortcuts);
        yield effects.call(monitorShortcutActions, actionQueue);
    } finally {
        // unregister the groups when the saga is cancelled
        yield effects.call(unregisterShortcuts, ShortcutsActions.unregisterShortcutGroup(registeredGroups));
    }
}

function* monitorShortcutActions(actionQueue: Channel<AnyAction>) {
    while (true) {
        const action = (yield effects.take(actionQueue)) as any;
        yield effects.put(action);
    }
}

function* unregisterShortcuts(action: ActionsOfType<ShortcutsActions, ShortcutsActionTypes.UnRegisterShortcutGroup>) {
    const pageContext: IVssPageContext = (yield effects.getContext("pageContext")) as any;
    const keyboardService = pageContext.getService<IVssKeyboardShortcutService>("IVssKeyboardShortcutService");

    const { shortcutGroupNames } = action.payload;
    for (const group of shortcutGroupNames) {
        yield effects.call([keyboardService, keyboardService.removeShortcutGroup], group);
    }
}

function* registerShortcuts(
    actionQueue: Channel<AnyAction>,
    registeredGroups: string[],
    action: ActionsOfType<ShortcutsActions, ShortcutsActionTypes.RegisterShortcutGroup>
) {
    const { shortcutGroups } = action.payload;

    const pageContext: IVssPageContext = (yield effects.getContext("pageContext")) as any;
    const keyboardService = pageContext.getService<IVssKeyboardShortcutService>("IVssKeyboardShortcutService");

    for (const group of shortcutGroups) {
        const { name, shortcuts } = group;
        registeredGroups.push(name);
        for (const s of shortcuts) {
            yield effects.call([keyboardService, keyboardService.registerShortcut], name, {
                ...s,
                // on action of the shortcut put the action in the action queue
                action: (e: IEKeyboardEvent, combo: string) => {
                    actionQueue.put(s.action);
                }
            });
        }
    }
}
